import { IAssignment } from '@medely/types';
import { Box, HStack, Label, Text } from '@medely/ui-kit';
import React from 'react';
import { InfoCircleButton } from './InfoCircleButton';
import { centsToCurrency } from '@mp/utils';
import useDialog from '@mp/hooks/useDialog';
import { StipendModal } from './stipendModal/StipendModal';
import { TaxableModal } from './taxableModal/TaxableModal';

export const TaxInfo = ({ assignment }: { assignment: IAssignment }) => {
  const stipendDialog = useDialog();
  const taxableDialog = useDialog();
  return (
    <>
      <HStack justifyContent="space-between">
        <Box>
          <HStack>
            <Label size="l" testId="compensation-group-taxable-amount-title">
              Tax free stipend
            </Label>
            <InfoCircleButton
              onClick={() => stipendDialog.openDialog()}
              testid="compensation-group-taxable-amount-info-circle"
            />
          </HStack>
        </Box>
        <Label size="l" testId="compensation-group-taxable-amount-non-taxable">
          {centsToCurrency(assignment.nontaxable_amount_cents || 0)}
        </Label>
      </HStack>
      {Boolean(assignment.lodging_per_diem_cents) && (
        <Text size="m" color="text.secondary" testId="compensation-group-taxable-amount-housing">
          Housing: {centsToCurrency(assignment.lodging_per_diem_cents)} /day
        </Text>
      )}
      {Boolean(assignment.mie_per_diem_cents) && (
        <Text size="m" color="text.secondary" testId="compensation-group-taxable-amount-mie">
          {`M&IE: ${centsToCurrency(assignment.mie_per_diem_cents)} /day`}
        </Text>
      )}
      <HStack justifyContent="space-between" mt={2}>
        <HStack testId="compensation-group-taxable-income">
          <Label size="l" testId="compensation-group-taxable-income-title">
            Taxable income
          </Label>
          <InfoCircleButton
            onClick={() => taxableDialog.openDialog()}
            testid="compensation-group-taxable-income-info-circle"
          />
        </HStack>
        <Label size="l" testId="compensation-group-taxable-income-taxable-amount">
          {centsToCurrency(assignment.taxable_amount_cents || 0)}
        </Label>
      </HStack>
      <StipendModal open={stipendDialog.open} onClose={stipendDialog.closeDialog} />
      <TaxableModal open={taxableDialog.open} onClose={taxableDialog.closeDialog} />
    </>
  );
};
